import * as React from 'react';
import clsx from 'clsx';

export type AccountTabId = 'profile' | 'billing' | 'earnings' | 'settings' | 'developer';

interface ProfileTabsProps {
  activeTab: AccountTabId;
  onTabChange: (tab: AccountTabId) => void;
  showEarningsTab?: boolean;
  showDeveloperTab?: boolean;
}

export const ProfileTabs: React.FC<ProfileTabsProps> = ({
  activeTab,
  onTabChange,
  showEarningsTab = false,
  showDeveloperTab = false,
}) => {
  const tabs: { id: AccountTabId; label: string }[] = [
    { id: 'profile', label: 'Profile' },
    { id: 'billing', label: 'Billing' },
    { id: 'settings', label: 'Settings' },
  ];

  if (showEarningsTab) {
    tabs.splice(2, 0, { id: 'earnings', label: 'Earnings' });
  }

  if (showDeveloperTab) {
    tabs.push({ id: 'developer', label: 'Developer' });
  }

  return (
    <div className='mb-8 flex items-center gap-8'>
      {tabs.map((tab) => {
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={clsx(
              'pb-3 font-sans text-16 leading-27 transition-colors',
              isActive
                ? 'font-bold text-dark-300 underline decoration-solid underline-offset-4'
                : 'font-medium text-dark-300 hover:text-dark-100'
            )}
            type='button'
          >
            {tab.label}
          </button>
        );
      })}
    </div>
  );
};
